import React, { useState, useEffect, useRef } from "react";
import Config from "../../utils/config";
import Request from "../../utils/Request";
import CsvDown from "../../components/ExportFiles/CsvDown";
import Pagination from "../../components/common/Pagination";
import { useNavigate } from "react-router-dom";
import { TableWarpper, TabsDetailsWrapper, Text, ButtonSolid } from "../../components/styledConstants";
import { Heading } from "../../components/styledConstants";
import { Wrapper } from "./style";
import IconDate from "../../assets/images/IconDate";
import { fromDateConvert, getParams, toDateConvert } from "../../utils/common";
import FilterBox from "../../components/common/FilterBox";
import { CSVLink, CSVDownload } from "react-csv";
import IconDownload from "../../assets/images/IconDownload";
import { dateConvertWithoutTime } from "../../utils/common";
import { FilterWrapper } from "../Merchants/style";

const paymentModeOptions = [
  { value: "P2P", label: "P2P" },
  { value: "BT", label: "BANK TRANSFER" },
  { value: "VA", label: "VIRTUAL ACCOUNT" },
  { value: "UPI_PAYMENT", label: "UPI PAYMENT" },
  { value: "UPI_COLLECT", label: "UPI COLLECT" },
  { value: "PREPAID_CARD", label: "PREPAID CARD" },
  { value: "BBPS", label: "BBPS" },
  { value: "MRE", label: "RECHARGE" },
  { value: "WALLET", label: "WALLET" },
  { value: "PAYMENT_GATEWAY", label: "PAYMENT GATEWAY" },
];

const statusOptions = [
    { value: "INITIATED", label: "INITIATED" },
    /*  {value: "DONE", label: "DONE" }, } */
    { value: "PENDING", label: "PENDING" },
    { value: "FAIL", label: "FAIL" },
    { value: "INPROCESS", label: "IN PROCESS" },
    { value: "DONE", label: "DONE" },
    /* { value: "REJECTED", label: "REJECTED" }, */
    { value: "REFUNDED", label: "REFUNDED" },
  ];
  const typeOptions = [
    { value: "DEBIT", label: "DEBIT" },
    { value: "CREDIT", label: "CREDIT" },
  ];
const filterForm = [
  {
    icon: <IconDate />,
    name: "fromDate",
    value: "",
    className: "item-text pl16",
    dateFormat: "d-MM-yyyy",
    type: "date",
    showMonthDropdown: true,
    showYearDropdown: true,
    yearDropdownItemNumber: 80,
    scrollableYearDropdown: true,
    placeholder: "From Date",
    maxDate: new Date(),
    error: "",
  },
  {
    icon: <IconDate />,
    name: "toDate",
    value: "",
    className: "item-text pl16",
    dateFormat: "d-MM-yyyy",
    type: "date",
    showMonthDropdown: true,
    showYearDropdown: true,
    yearDropdownItemNumber: 80,
    scrollableYearDropdown: true,
    placeholder: "To Date",
    maxDate: new Date(),
    error: "",
  },
 

 
  
  {
    name: "refTransactionId",
    value: "",
    type: "text",
    placeholder: "Ref Txn Id",
  },
  {
    name: "orgCode",
    value: "",
    type: "text",
    placeholder: "Org Name",
  },
  
];

export default function OrgSetteleMentReport() {
  const [controls, setControls] = useState([...filterForm]);
  const [filterFormData, setFilterFormData] = useState({ fromDate: "", toDate: "" });
  const [headers, setHeaders] = useState([]);
  const [reportName, setReportName] = useState("report.csv");
  const [reportList, setReportList] = useState({});
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [downloadPayload, setDownloadPayload] = useState({});
  const [loading, setLoading] = useState(false);
  const [columnKeys, setColumnKeys] = useState([]);
  const [downloadData, setDownloadData] = useState([]);
  const [totalElements, setTotalElements] = useState(10);
 const [isCsvDownloading, setIsCsvDownloading] = useState(false);

  let navigate = useNavigate();
  const csvLinkRef = useRef(null);

  const header =[
      { label: "Card Ending Number", key: "cardNumber" },

    
  ]

  const onFilterChange = (event, index) => {
  const _controls = [...controls];
  const value =
    event instanceof Date || (event && event.label) ? event : event ? event.target.value : event;

  _controls[index].value = value;

  if (_controls[index].name === "fromDate") {
    const sameDate = new Date(value);
    _controls[1].minDate = sameDate;
    _controls[1].maxDate = sameDate;
     _controls[1].value = sameDate;
  }

  _controls[index].error = "";

  setControls([..._controls]);
};

  const onFilterSubmit = (e) => {
    e.preventDefault();
    const params = getParams(controls);
    const _controls = [...controls];
    if ((params.toDate === "" || params.toDate === null) && params.fromDate !== "" && params.fromDate !== null) {
      _controls[1].error = "Please select to date";
    } else if (params.toDate !== "" && params.toDate !== null && (params.fromDate === "" || params.fromDate === null)) {
      _controls[0].error = "Please select from date";
    } else {
      _controls[1].error = "";
      _controls[0].error = "";
      setControls([..._controls]);
      getReportList(1);
    }
    setControls([..._controls]);
 


  
    setCurrentPage(1);
 };

  const getReportList = (page = 1) => {
    const successHandler = (res) => {
      console
      setLoading(false);
      if (res) {
        if (res?.data?.content) {
          setTotalPages(res?.data?.totalPages);
          setTotalElements(res?.data?.totalElements);
          let listKeys = [];
          if (res?.data?.content[0]) {
            listKeys = Object.keys(res?.data?.content[0]);
          }
          setColumnKeys(listKeys);
          setReportList(res?.data?.content);
          let _downloadData = [];

          _downloadData.push(listKeys);

          res?.data?.content.map((item) => {
            let _downloadItemData = [];
            listKeys.map((keyname) => {
              _downloadItemData.push(item[keyname]);
            });
            _downloadData.push(_downloadItemData);
          });
          setDownloadData(_downloadData);
        } else {
          setReportList([]);
          setColumnKeys([]);
          setDownloadData([]);
          setTotalPages(1);
        }
      }
    };
    const errorHandler = () => {};
    const api = new Request("", successHandler, errorHandler, false);
    setLoading(true);
    const params = getParams(controls);
    let payload = {
     
    
        fromDate: params?.fromDate ? fromDateConvert(params.fromDate) : fromDateConvert(new Date()),
        toDate: params?.toDate ? toDateConvert(params.toDate) : toDateConvert(new Date()), 
         orgCode:params?.orgCode,
         refTransactionId:params?.refTransactionId,
     
      pagination: {
        pageNo: page,
        pageSize: 10,
      },
    };
    setDownloadPayload(payload);
    setReportName(params?.transactionType?.value + ".csv");
    return api.post(`${Config.apis.admin.ORG_SETTELEMENT_REPORT}`, payload);
  };

  const downloadReportList = () => {
    if (isCsvDownloading) return; 

  setIsCsvDownloading(true);
    const successHandler = (res) => {
      if (res) {
        if (res.data?.content) {
          let listKeys = [];
          if (res?.data?.content[0]) {
            listKeys = Object.keys(res?.data?.content[0]);
          }

          let _downloadData = [];
          _downloadData.push(listKeys);
          res?.data?.content.map((item) => {
            let _downloadItemData = [];
            listKeys.map((keyname) => {
              _downloadItemData.push(item[keyname]);
            });
            _downloadData.push(_downloadItemData);
          });
          setDownloadData(_downloadData);
          setTimeout(() => {
            csvLinkRef.current.link.click();
          }, 0);
        }
      }
      
    };
    
    const errorHandler = () => {
      
    };
    setTimeout(() => {
setIsCsvDownloading(false);
}, 15000);

    const params = getParams(controls);
    const pagination = {
      pageNo: 1,
      pageSize: totalElements,
    }
    let payload = {...downloadPayload,pagination:pagination };
    const api = new Request("", successHandler, errorHandler, false);
 
    return api.post(`${Config.apis.admin.ORG_SETTELEMENT_REPORT}`, payload);
  };

  const clearMessage = () => {
    setTimeout(() => {
      const _controls = [...controls];
      _controls[0].error = "";
      _controls[1].error = "";
      _controls[2].error = "";
      setControls([..._controls]);
    }, 3000);
  };
  const setActivePage = (page) => {
    setCurrentPage(page);
    getReportList(page);
  };
  useEffect(()=>{
    getReportList();
  },[])
  const resetFilter = () => {
    filterForm.forEach((obj) => {
      obj.value = "";
    });
  };
  const refreshPage = () => {
    resetFilter();
    setCurrentPage(1);
    getReportList();
  };

  useEffect(()=>{
    return(()=>{
      resetFilter();
    })
  },[])
  return (
    <Wrapper>
      <div className="flex flex-center space-between mb10">
        <>
          <Heading size="xxl">Org Settelement Report</Heading>
          <div className="flex gap10">
           

          {/* <CsvDown  url={`${Config.apis.admin.REPORT_BY_TRANSACTION}`} filename={reportName} className="flex"></CsvDown> */}
          
          <ButtonSolid
           as="span"
           className="flex flex-center"
           primary
           lg
           onClick={downloadReportList}
           disabled={isCsvDownloading}
           style={{ cursor: isCsvDownloading ? "not-allowed" : "pointer", opacity: isCsvDownloading ? 0.6 : 1 }}
             >
            <IconDownload className="mr8" />
            {isCsvDownloading ? "Please wait..." : "CSV"}
          </ButtonSolid>
          <CSVLink  className="flex" data={downloadData}  filename={"report.csv"} ref={csvLinkRef}>
   
      </CSVLink>
          {/* {downloadData.length > 1 ? (
            <ButtonSolid as="span" className="flex flex-center" primary lg onClick={downloadReportList}>
              <IconDownload className="mr8" />CSV
            </ButtonSolid>
          ) : (
            <ButtonSolid as="span" className="flex flex-center"  lg>
              <IconDownload className="mr8" />CSV
            </ButtonSolid>
          )} */}
          </div>
        </>
      </div>
      <div className="mt32">
        <TabsDetailsWrapper>
        <FilterWrapper>  <FilterBox 
          filterForm={filterForm} 
          onFilterChange={onFilterChange} 
          onFilterSubmit={onFilterSubmit}
          refreshPage={refreshPage}
          /></FilterWrapper>
        
        
                     <TableWarpper className="mt50">
                          <table className="table">
                            <thead>
                              <tr>
                                <th className="text-left">
                                  <Text size="rg" fw="medium">
                                  Transaction Type
                                    
                                  </Text>
                                </th>
                                <th className="text-left">
                                  <Text size="rg" fw="medium">
                                  Transaction Mode
                                  </Text>
                                </th>
                                <th className="text-left">
                                  <Text size="rg" fw="medium">
                                
                                  Settlement Amount
                                  </Text>
                                </th>
                             
                                <th className="text-left">
                                  <Text size="rg" fw="medium">
                                  Transaction Status
                                  </Text>
                                </th>
                                <th className="text-left">
                                  <Text size="rg" fw="medium">
                                  Settlement  Count
                                  </Text>
                                </th>
        
                                <th className="text-left">
                                  <Text size="rg" fw="medium">
                                  Transaction Id
                                  </Text>
                                </th>
                                <th className="text-left">
                                  <Text size="rg" fw="medium">
                                  Service Fee
                                  </Text>
                                </th>
                                <th className="text-left">
                                  <Text size="rg" fw="medium">
                                  Gst Charge
                                  </Text>
                                </th>
                                <th className="text-left">
                                  <Text size="rg" fw="medium">
                                  Ref Txn Id
                                  </Text>
                                </th>
                  
                                <th className="text-left">
                                  <Text size="rg" fw="medium">
                                  Org Name
                                  </Text>
                                </th>
                                <th className="text-left">
                                  <Text size="rg" fw="medium">
                                  Narration
                                  </Text>
                                </th>
                                <th className="text-left">
                                  <Text size="rg" fw="medium">
                                Updated Date
                                  </Text>
                                </th>
                                <th className="text-left">
                                  <Text size="rg" fw="medium">
                                Created Date
                                  </Text>
                                </th>
                             </tr>
                            </thead>
                            <tbody>
                              {reportList.length ? (
                                reportList.map((list, index) => (
                                  <tr key={index}>
                                    <td>
                                      <Text size="xsm" color="color3">
                                        {list?.transactionType}
                                      </Text>
                                    </td>
                                    <td>
                                      <Text size="xsm" color="color3">
                                        {list.transactionMode}
                                      </Text>
                                    </td>
                  
                                    <td>
                                      <Text size="xsm" color="color3">
                                        {list?.settlementAmount}
                                      </Text>
                                    </td>
                                    <td>
                                      <Text size="xsm" color="color3">
                                        {list?.txnStatus}
                                      </Text>
                                    </td>
                                  
                                    <td>
                                     
                                      <Text size="xsm" color="color3">
                                        {list?.settlementTxnCount}
                                     
                                      </Text>
                                    </td>
                                    <td>
                                      <Text size="xsm" color="color3">
                                        {list?.voucherId}
                                      </Text>
                                    </td>
                                    <td>
                                      <Text size="xsm" color="color3">
                                        {list?.serviceFee}
                                      </Text>
                                    </td>
                                    <td>
                                      <Text size="xsm" color="color3">
                                        {list?.gstCharge}
                                      </Text>
                                    </td>
                                    <td>
                                      <Text size="xsm" color="color3">
                                        {list?.rrn}
                                      </Text>
                                    </td>
                                    <td>
                                      <Text size="xsm" color="color3">
                                        {list?.orgCode}
                                      </Text>
                                    </td>
                                  
                                    <td>
                                      <Text size="xsm" color="color3">
                                        {list?.narration}
                                      </Text>
                                    </td>
                                    <td>
                                      <Text size="xsm" color="color3">
                                        {list?.updatedAt ?list?.updatedAt.split("T")[0]+" "+ list?.updatedAt?.split("T")[1]?.split(".")?.[0] : ""}
                                      </Text>
                                    </td>
                                    <td>
                                      <Text size="xsm" color="color3">
                                      {list?.createdAt ?list?.createdAt.split("T")[0]+" "+ list?.createdAt?.split("T")[1]?.split(".")?.[0] : ""}
                                      </Text>
                                    </td>
                                 
                                  
                                    
                                  
                                
                                          
                                          
                                          
                                           
                                                         
                                    
                                 
                                  </tr>
                                ))
                              ) : !loading ? (
                                <tr>
                                  <td colSpan={12} style={{ textAlign: "center" }}>No record found</td>
                                </tr>
                              ) : (
                                ""
                              )}
                            </tbody>
                          </table>
                        </TableWarpper>

          <div className="mt24 flex flex-center">
            {totalPages > 1 && (
              <Pagination
                totalPages={totalPages}
                currentPage={currentPage}
                getCurrentPageData={(curpage) => {
                  setActivePage(curpage);
                }}
              />
            )}
          </div>
        </TabsDetailsWrapper>
      </div>
    </Wrapper>
  );
}
